import { INBOXS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import { inboxs } from "@/dev/data"

export const getOne = ({ commit,dispatch }, id) => {

    const url = `${INBOXS_API}/${id}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)

    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        dispatch("messages/list/getAll",id,{root:true})
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        //dev
        commit(types.SET_ITEMS, inboxs.find((inb) => inb.id == id));
        dispatch("messages/list/getAll",id,{root:true})
        
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)



    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



